import { IField, IFormButton } from 'app/services/api5-service/api.interface';
import { getButtonList } from 'components/form-button/form-button.utils';
import { IFormButtonUi } from 'components/form-button/model';
import { Observable, combineLatest, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { ISPFormState } from 'common/dynamic-form/model';

import { FieldSettings } from '../model';

/**
 * Get visible field buttons for field
 *
 * @param field - field metadata
 */
export function getFieldButtons(field: IField): IFormButton[] | undefined {
  if (!field.button) {
    return;
  }

  const buttons = Array.isArray(field.button) ? field.button : [field.button];
  return buttons.filter(
    button => button.$position === 'underfield' && button.$hidden !== 'yes',
  );
}

/**
 * Get stream of buttons for field
 *
 * @param field
 * @param state
 * @param fieldSettings$
 */
export function getFieldButtons$(
  field: IField,
  state: ISPFormState,
  fieldSettings$: Observable<FieldSettings | undefined>,
): Observable<IFormButtonUi[] | undefined> {
  return combineLatest([fieldSettings$, state.docSubject]).pipe(
    switchMap(([fieldSettings, doc]) => {
      if (fieldSettings?.customButtons$) {
        return fieldSettings.customButtons$;
      }

      const fieldButtons = getFieldButtons(field);
      if (!fieldButtons) {
        return of(undefined);
      }

      return of(getButtonList(doc, fieldButtons, false));
    }),
    shareReplay({
      refCount: true,
      bufferSize: 1,
    }),
  );
}
